module.exports = __webpack_public_path__ + "img/usa-logo.7f476723.jpg";